import { Component, inject, OnInit } from '@angular/core';
import { FormGroup, FormControl, Validators, FormGroupDirective } from '@angular/forms';
import { Router } from '@angular/router';
import { AuthService } from 'src/app/services/auth/auth.service';
import { CommonService } from 'src/app/services/common/common.service';
import { LoginService } from 'src/app/services/login/login.service';
import { ErrorData, MessageService } from 'src/app/services/message/message.service';
import { CustomvalidationService } from 'src/app/services/validators/custom-validation.service';
import { ValidatorService } from 'src/app/services/validators/errors-validators.service';
import { AlterarSenhaRequest } from 'src/models/interfaces/login/login-interface';
import { HomeComponent } from '../../home/home.component';
import { MatSnackBar } from '@angular/material/snack-bar';
import { SnackbarComponent } from 'src/app/shared/components/snackbar/snackbar.component';

@Component({
  selector: 'spe-alterar-senha',
  templateUrl: './alterar-senha.component.html',
  styleUrls: ['./alterar-senha.component.scss'],
  standalone: false
})
export class AlterarSenhaComponent implements OnInit {
  public rule1: boolean = false;
  public rule2: boolean = false;
  public rule3: boolean = false;
  public rule4: boolean = false;
  public rule5: boolean = false;
  public rule6: boolean = false;
  public rule7: boolean = false;
  validatorErrors = this.validatorService.validatorErrors;
  public apiStatus: string | null = null;
  public message: string = '';
  public hidePassword = true;
  public hideNewPassword = true;
  public hideRepeatNewPassword = true;
  public sigla = localStorage.getItem('sigla');
  passwordTouched = false;
  public mainFormGroup = new FormGroup(
    {
      oldPassword: new FormControl('', [Validators.required, Validators.minLength(8)]),
      password: new FormControl('', [Validators.required, Validators.minLength(8), this.validarSenha.bind(this)]),
      passwordConfirm: new FormControl('', [Validators.required, Validators.minLength(8)])
    },
    { validators: [this.customValidator.matchingPasswords] }
  );
  flag: string = localStorage.getItem('flagAlterarSenha') ?? '';
  private _snackBar = inject(MatSnackBar);

  constructor(
    public readonly routerService: Router,
    public readonly validatorService: ValidatorService,
    public readonly commonService: CommonService,
    public readonly customValidator: CustomvalidationService,
    public readonly authService: AuthService,
    private loginService: LoginService,
    private messageService: MessageService,
    private homeComponent: HomeComponent
  ) {}

  ngOnInit(): void {
    this.mainFormGroup.controls.password.valueChanges.subscribe(() => {
      this.passwordTouched = true;
    });
    this.setHomeVariables();
    this.subscribeMessageService();
    this.setFormData();
  }

  setHomeVariables() {
    this.homeComponent.idleMenuContent = [];
    this.homeComponent.setNewVariables(
      'Alterar senha',
      'Para alterar sua senha preencha os campos abaixo informando a senha atual e a nova senha.'
    );
    this.homeComponent.iconPath = 'assets/images/64_icon_shield_yellow.png';
  }

  setFormData() {
    if (this.flag == 'true') {
      this.homeComponent.showQuadroAvisos = false;
      this.mainFormGroup.controls.oldPassword.setValue(localStorage.getItem('old-password'));
      localStorage.removeItem('old-password');
      this.mainFormGroup.markAsUntouched();
      this.passwordTouched = false;
    }
  }

  private readonly showMessage = (text: string = '', errorMessage: boolean = false) => {
    this.apiStatus = errorMessage ? 'error' : 'success';
    this.message = text;
  };

  subscribeMessageService() {
    this.messageService.errorData$.subscribe((errorData: ErrorData) => {
      this.showMessage(errorData.errorMessage, errorData.isError);
    });
  }

  public returnButton = () => {
    this.routerService.navigate([`home`]);
  };

  public submitButton = (formDirective: FormGroupDirective) => {
    this.mainFormGroup.markAllAsTouched();
    let idParceria = localStorage.getItem('idParceria') == '2' ? 2 : null;
    if (this.mainFormGroup.valid) {
      let request: AlterarSenhaRequest = {
        senhaAtual: this.mainFormGroup.controls.oldPassword.value!,
        senhaNova: this.mainFormGroup.controls.password.value!,
        confirmacaoDaSenhaNova: this.mainFormGroup.controls.passwordConfirm.value!,
        login: localStorage.getItem('login')!,
        
        idParceria: idParceria
      };
      this.loginService.alterarSenha(request).subscribe({
        next: () => {
          // this.hideEverything = true;
          this.cleanForm(formDirective);
        }
      });
    }
  };

  cleanForm(formDirective: FormGroupDirective) {
    this.commonService.autoScroll();
    this.mainFormGroup.reset();
    formDirective.resetForm();
    this.mainFormGroup.markAsPristine();
    this.mainFormGroup.markAsUntouched();
    this.mainFormGroup.updateValueAndValidity();
    this.hidePassword = true;
    this.hideNewPassword = true;
    this.hideRepeatNewPassword = true;
    this.rule1 = false;
    this.rule2 = false;
    this.rule3 = false;
    this.rule4 = false;
    this.rule5 = false;
    this.rule6 = false;
    this.rule7 = false;
  }

  public openSnackBar(message: string) {
    this._snackBar.openFromComponent(SnackbarComponent, {
      duration: 10000,
      data: { message: message }
    });
  }

  validarSenha(control: any) {
    const senha = control.value;
    this.rule1 = senha?.length >= 8;
    this.rule2 = /[!@#$()&*]/.test(senha);
    this.rule3 = /[A-Z]/.test(senha);
    this.rule4 = /[a-z]/.test(senha);
    this.rule5 = /[0-9]/.test(senha);
    this.rule6 = !/\s/.test(senha);
    this.rule7 = !/[^a-zA-Z0-9!@#$()&*]/.test(senha);

    const regrasValidacao = [this.rule1, this.rule2, this.rule3, this.rule4, this.rule5, this.rule6, this.rule7];

    const isValid = regrasValidacao.every((regra) => regra);

    return !isValid ? { senhaInvalida: true } : null;
  }

  logout() {
    this.loginService.deslogar().subscribe({
      next: () => {
        this.loginService.removeLoginData();
        this.routerService.navigate(['login/logout']);
      }
    });
  }
}
